"use strict";
module.exports = Number.isNaN || function isNaN(a) {
  return a !== a;
};
